module.exports = __webpack_public_path__ + "static/media/imsg_img_scr.19644887.png";